module.exports = __webpack_public_path__ + "img/pleion-logo.2722a492.svg";